import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';
import { PutRequestArgsType } from '@api/v1/types';

export const apiUpdateCurrentUserImage = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PutRequestArgsType<FormData>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.currentUserImage(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
